// import React, { useState, useEffect } from "react";
// import { Box, Paper, IconButton } from "@mui/material";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
// import { carouselItems } from "./data";

// const Carousel = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === carouselItems.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const handlePrevious = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? carouselItems.length - 1 : prevIndex - 1
//     );
//   };

//   // Automatic scrolling every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       handleNext();
//     }, 4000);

//     // Cleanup interval on component unmount or when currentIndex changes
//     return () => clearInterval(interval);
//   }, [currentIndex]);

//   const currentItem = carouselItems[currentIndex];

//   return (
//     <Box
//       sx={{
//         width: "100%", // Full width for responsiveness
//         maxWidth: { xs: "100%", sm: "100%", md: "90%", lg: "90%", xl: "80%" }, // Kept as is
//         margin: "auto",
//         padding: 0,
//         borderRadius: 2,
//         backgroundColor: "white",
//         marginTop: 6,
//       }}
//     >
//       <Paper
//         elevation={1}
//         sx={{
//           padding: { xs: 0, sm: 1 },
//           overflow: "hidden", // Ensure content stays within bounds
//         }}
//       >
//         {/* Carousel Container */}
//         <Box
//           sx={{
//             position: "relative",
//             width: "100%",
//             // Removed aspectRatio to allow images to determine height
//             height: {
//               xs: "auto",
//               sm: "auto",
//               md: "auto",
//               lg: "auto",
//               xl: "auto",
//             }, // Dynamic height based on image
//           }}
//         >
//           {/* Slide Content */}
//           <Box
//             sx={{
//               width: "100%",
//               height: "100%",
//               overflow: "hidden",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <img
//               src={currentItem.url}
//               alt={currentItem.title}
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain", // Changed to "contain" to avoid cropping
//               }}
//             />
//           </Box>

//           {/* Navigation Arrows */}
//           <IconButton
//             onClick={handlePrevious}
//             sx={{
//               position: "absolute",
//               top: "50%",
//               left: { xs: 5, sm: 10, md: 20, lg: 30, xl: 40 },
//               transform: "translateY(-50%)",
//               zIndex: 2,
//               backgroundColor: "rgba(0, 0, 0, 0.2)",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//               },
//               display: { xs: "none", sm: "flex" }, // Hide arrows on mobile (optional)
//             }}
//           >
//             <NavigateBeforeIcon />
//           </IconButton>
//           <IconButton
//             onClick={handleNext}
//             sx={{
//               position: "absolute",
//               top: "50%",
//               right: { xs: 5, sm: 10, md: 20, lg: 30, xl: 40 },
//               transform: "translateY(-50%)",
//               zIndex: 2,
//               backgroundColor: "rgba(0, 0, 0, 0.2)",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//               },
//               display: { xs: "none", sm: "flex" }, // Hide arrows on mobile (optional)
//             }}
//           >
//             <NavigateNextIcon />
//           </IconButton>

//           {/* Indicators */}
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: { xs: 5, sm: 10, md: 20, lg: 25, xl: 30 },
//               left: 0,
//               right: 0,
//               display: "flex",
//               justifyContent: "center",
//               gap: { xs: 0.5, sm: 1, md: 1.5, lg: 2, xl: 2.5 },
//               zIndex: 2,
//             }}
//           >
//             {carouselItems.map((_, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   width: { xs: 8, sm: 10, md: 12, lg: 14, xl: 16 },
//                   height: { xs: 8, sm: 10, md: 12, lg: 14, xl: 16 },
//                   borderRadius: "50%",
//                   backgroundColor:
//                     index === currentIndex
//                       ? "primary.main"
//                       : "rgba(88, 87, 87, 0.5)",
//                   cursor: "pointer",
//                   transition: "background-color 0.3s",
//                 }}
//                 onClick={() => setCurrentIndex(index)}
//               />
//             ))}
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default Carousel;

import React, { useState, useEffect } from "react";
import { Box, Paper, IconButton, Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { carouselItems } from "./data";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === carouselItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carouselItems.length - 1 : prevIndex - 1
    );
  };

  // Automatic scrolling with pause functionality
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        handleNext();
      }, 60000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, isPaused]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: "100%", md: "90%", lg: "90%", xl: "80%" },
        margin: "auto",
        borderRadius: 2,
        backgroundColor: "white",
        marginTop: 6,
      }}
    >
      <Paper
        elevation={1}
        sx={{
          padding: { xs: 0, sm: 1 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={carouselItems[currentIndex].url}
              alt={carouselItems[currentIndex].title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Navigation Arrows */}
          <IconButton
            onClick={handlePrevious}
            sx={{
              position: "absolute",
              top: "50%",
              left: { xs: 5, sm: 10, md: 20, lg: 30, xl: 40 },
              transform: "translateY(-50%)",
              zIndex: 2,
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
              display: { xs: "none", sm: "flex" },
            }}
          >
            <NavigateBeforeIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: { xs: 5, sm: 10, md: 20, lg: 30, xl: 40 },
              transform: "translateY(-50%)",
              zIndex: 2,
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
              display: { xs: "none", sm: "flex" },
            }}
          >
            <NavigateNextIcon />
          </IconButton>

          {/* Indicators */}
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 40, sm: 50 },
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              gap: { xs: 0.5, sm: 1, md: 1.5, lg: 2, xl: 2.5 },
              zIndex: 2,
            }}
          >
            {carouselItems.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: { xs: 8, sm: 10, md: 12, lg: 14, xl: 16 },
                  height: { xs: 8, sm: 10, md: 12, lg: 14, xl: 16 },
                  borderRadius: "50%",
                  backgroundColor:
                    index === currentIndex
                      ? "primary.main"
                      : "rgba(88, 87, 87, 0.5)",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 2,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 2,
              display: "flex",
              alignItems: "center",
              gap: 1, // Space between icon and text
            }}
          >
            <IconButton
              color="primary"
              onClick={() => setIsPaused((prev) => !prev)}
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                },
              }}
            >
              {isPaused ? <PlayArrowIcon /> : <PauseIcon />}
            </IconButton>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Carousel;
